import type React from 'react';
import type { BaseAdConfig } from 'interfaces/ads/Ad';
import ADS_TEST_IDS from 'constants/testsIds/ads';
import { InStreamAd, AdsCenteredDiv } from './Styles';
import AdSlotToggle from './AdSlotToggle';

const HomePageInStream: React.FC<BaseAdConfig> = ({ id }: BaseAdConfig) => (
  <AdsCenteredDiv>
    <InStreamAd
      data-cy={`${ADS_TEST_IDS.HP_IN_STREAM}-${id}`}
      className='homepage'
    >
      <AdSlotToggle
        placementName='Homepage-InStream'
        index={id + 1}
        dataCy={`${ADS_TEST_IDS.HP_IN_STREAM}-${id}-child`}
        slotId={`InStream${id}`}
      />
    </InStreamAd>
  </AdsCenteredDiv>
);

export default HomePageInStream;
